import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from "@angular/material";

import { SharedService } from "./../../shared/shared.service";
import { DevoteeService } from './../devotee.service';
import { ActionStatusService } from "./../../shared/action-status.service";
import { DevoteeDetail } from "./../devotee-detail";
import { DevoteeMessageForAdminComponent } from "./../devotee-message-for-admin/devotee-message-for-admin.component";

@Component({
  selector: 'app-devotee-profile',
  templateUrl: './devotee-profile.component.html',
  styleUrls: ['./devotee-profile.component.css']
})
export class DevoteeProfileComponent implements OnInit {

  constructor(private formBuilder: FormBuilder,
    private devoteeService: DevoteeService,
    private sharedService: SharedService,
    private actionStatusService: ActionStatusService,
    private activeRoute: ActivatedRoute,
    private dialog: MatDialog) { }


  devoteeForm: FormGroup;
  stateList: string[] = [];
  devoteeDetail: DevoteeDetail;
  savedMessage: string = "";
  errorMessage: string = "";

  ngOnInit() {
    this.devoteeDetail = this.sharedService.getDevoteeDataAtLocStorage();
    console.log(this.devoteeDetail);

    this.stateList = this.sharedService.StateLists;
    this.createEditDevoteeForm(this.devoteeDetail);
  }

  saveForm(actionId: number): void {
    let devoteeDetail: DevoteeDetail = this.devoteeForm.value;

    if (this.devoteeForm.invalid) {
      this.sharedService.validateAllFormFields(this.devoteeForm);
      console.log(this.devoteeForm.errors);
      return;
    }

    // Save Devotee
    devoteeDetail.actionId = actionId;
    devoteeDetail.PinCode = devoteeDetail.PinCode.toString();
    this.sharedService.showSpinner();
    this.devoteeService.updateDevotee(devoteeDetail).subscribe(
      data => {
        this.devoteeForm.markAsPristine();
        this.savedMessage = "Profile updated sucessfully.";
        this.refreshDevoteeDataAtLocStorage();
        console.log(data);
      },
      err => {
        this.errorMessage = err.error.Message;
        console.log(this.errorMessage);
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )
  }

  refreshDevoteeDataAtLocStorage(): void {
    this.sharedService.showSpinner();
    this.devoteeService.getUserProfile().subscribe(
      data => {
        if (!data) {
          this.errorMessage = "Mobile number is not registered";
          return;
        }
        this.sharedService.setDevoteeDataAtLocStorage(data)
        this.devoteeDetail = data;
      },
      err => console.log(err),
      () => this.sharedService.hideSpinner()
    )
  }

  resetForm(): void {
    this.devoteeForm.reset();
    this.devoteeForm.controls.Id.setValue(0);
    this.savedMessage = "";
    this.errorMessage = "";
  }

  openDevoteeMsg(): void {
    let matDialogRef = this.dialog.open(DevoteeMessageForAdminComponent, { disableClose: false });

    matDialogRef.afterClosed().subscribe(
      data => this.savedMessage = data
    )
  }

  createEditDevoteeForm(devoteeDetail: DevoteeDetail): void {
    this.devoteeForm = this.formBuilder.group({
      Id: [devoteeDetail.Id],
      FirstName: [devoteeDetail.FirstName, Validators.required],
      MiddleName: [devoteeDetail.MiddleName],
      LastName: [devoteeDetail.LastName, Validators.required],
      AddressLine1: [devoteeDetail.AddressLine1, Validators.maxLength(28)],
      AddressLine2: [devoteeDetail.AddressLine2, Validators.maxLength(28)],
      AddressLine3: [devoteeDetail.AddressLine3, Validators.maxLength(28)],
      AddressLine4: [devoteeDetail.AddressLine4, Validators.maxLength(28)],
      City: [devoteeDetail.City, Validators.required],
      State: [devoteeDetail.State, Validators.required],
      PinCode: [devoteeDetail.PinCode, [Validators.required, Validators.max(999999)]],
      MobileNo: [devoteeDetail.MobileNo, Validators.required],
      Email: [devoteeDetail.Email]
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/devotee/devotee-profile/devotee-profile.component.ts